export default __webpack_public_path__ + "9708d2d1c6abbf212bb1962ae2770da4.png";